export const styles = {
  circularProgress: {
    position: 'relative',
    top: 'calc(50% - 45px)',
    left: 'calc(50% - 45px)'
  },
  wrapper: { height: "300px" }
};